/* eslint-disable */
export const environment = {
  apiUrl: 'https://api-demo.swipesum.com/api',
  authUrl: 'https://api-demo.swipesum.com/api',
  gatewayUrl: 'https://gateway-demo.swipesum.com',
  setRoot: true,
  logLevel: 4,
  reportLogging: false,
  portalUrl: 'https://portal-demo.swipesum.com',
  suiteUrl: 'https://cpo-staging.swipesum.com',
  auditUrl: 'https://audit-staging.swipesum.com'
};